class BasicHeader extends HTMLElement{constructor(){super()}
get headerSection(){return document.querySelector('.header-section')}
get enableTransparent(){return this.dataset.enableTransparent==='true'}
connectedCallback(){this.init();if(window.ResizeObserver){new ResizeObserver(this.setHeight.bind(this)).observe(this)}
if(Shopify.designMode){const section=this.closest('.shopify-section');section.addEventListener('shopify:section:load',this.init.bind(this));section.addEventListener('shopify:section:unload',this.init.bind(this));section.addEventListener('shopify:section:reorder',this.init.bind(this))}}
init(){new FoxTheme.delayUntilInteraction(this.setHeight.bind(this));if(this.enableTransparent){this.headerSection.classList.add('header-transparent')}}
setHeight(){requestAnimationFrame(()=>{const offsetHeight=Math.round(this.offsetHeight);const offsetTop=Math.round(this.parentElement.offsetTop);document.documentElement.style.setProperty('--header-height',`${offsetHeight}px`);document.documentElement.style.setProperty('--header-offset-top',`${offsetTop}px`)})}}
customElements.define('basic-header',BasicHeader,{extends:'header'});class StickyHeader extends BasicHeader{constructor(){super();this.classes={pinned:'header-pinned',}}
get isAlwaysSticky(){return this.dataset.stickyType==='always'}
connectedCallback(){super.connectedCallback();this.currentScrollTop=0;this.firstScrollTop=window.scrollY;this.headerBounds=this.headerSection.getBoundingClientRect();this.beforeInit()}
beforeInit(){this.headerSection.classList.add('header-sticky');this.headerSection.dataset.stickyType=this.dataset.stickyType;window.addEventListener('scroll',this.onScrollHandler.bind(this),!1)}
onScrollHandler(){const scrollTop=window.scrollY;const headerSection=this.headerSection;const headerBoundsTop=this.headerBounds.top+this.firstScrollTop;const headerBoundsBottom=this.headerBounds.bottom+this.firstScrollTop;requestAnimationFrame(()=>{if(scrollTop>headerBoundsTop){headerSection.classList.add('header-scrolled');if(this.isAlwaysSticky){document.body.classList.add(this.classes.pinned)}else{if(scrollTop<this.currentScrollTop||scrollTop<headerBoundsBottom+100){document.body.classList.add(this.classes.pinned)}else{document.body.classList.remove(this.classes.pinned)}}}else{headerSection.classList.remove('header-scrolled');document.body.classList.remove(this.classes.pinned)}
this.currentScrollTop=scrollTop})}}
customElements.define('sticky-header',StickyHeader,{extends:'header'});const clearDropdownCount=new WeakMap();class DetailsDropdown extends HTMLDetailsElement{constructor(){super();this.classes={bodyClass:'has-dropdown-menu'};this.events={handleAfterHide:'menu:handleAfterHide',handleAfterShow:'menu:handleAfterShow',};this.summaryElement=this.firstElementChild;this.contentElement=this.lastElementChild;this._open=this.hasAttribute('open');this.summaryElement.addEventListener('click',this.handleSummaryClick.bind(this));if(this.trigger==='hover'){this.summaryElement.addEventListener('focusin',(event)=>{if(event.target===this.summaryElement){this.open=!0}});this.summaryElement.addEventListener('focusout',(event)=>{if(!this.contentElement.contains(event.relatedTarget)){this.open=!1}})}
this.handleOutsideClick=this.handleOutsideClick.bind(this);this.handleEscKeyPress=this.handleEscKeyPress.bind(this);this.handleFocusOut=this.handleFocusOut.bind(this);this.hoverTimer=null;this.detectHoverListener=this.detectHover.bind(this);this.addEventListener('mouseenter',this.detectHoverListener.bind(this));this.addEventListener('mouseleave',this.detectHoverListener.bind(this))}
set open(value){if(value!==this._open){this._open=value;if(this.isConnected){this.transition(value)}else{if(value){this.setAttribute('open','')}else{this.removeAttribute('open')}}}}
get open(){return this._open}
get trigger(){if(FoxTheme.config.isTouch){return'click'}
return this.getAttribute('trigger')||'click'}
get level(){if(this.hasAttribute('level')){return this.getAttribute('level')}else{return'top'}}
handleSummaryClick(event){event.preventDefault();if(!FoxTheme.config.isTouch&&this.trigger==='hover'&&this.summaryElement.hasAttribute('data-link')){window.location.href=this.summaryElement.getAttribute('data-link')}else{this.open=!this.open}}
async transition(value){if(value){clearDropdownCount.set(DetailsDropdown,clearDropdownCount.get(DetailsDropdown)+1);document.body.classList.add(this.classes.bodyClass);this.setAttribute('open','');this.summaryElement.setAttribute('open','');setTimeout(()=>this.contentElement.setAttribute('open',''),100);document.addEventListener('click',this.handleOutsideClick);document.addEventListener('keydown',this.handleEscKeyPress);document.addEventListener('focusout',this.handleFocusOut);await this.showWithTransition();this.needsReverse();return FoxTheme.utils.waitForEvent(this,this.events.handleAfterShow)}else{clearDropdownCount.set(DetailsDropdown,clearDropdownCount.get(DetailsDropdown)-1);document.body.classList.toggle(this.classes.bodyClass,clearDropdownCount.get(DetailsDropdown)>0);this.summaryElement.removeAttribute('open');this.contentElement.removeAttribute('open');document.removeEventListener('click',this.handleOutsideClick);document.removeEventListener('keydown',this.handleEscKeyPress);document.removeEventListener('focusout',this.handleFocusOut);await this.hideWithTransition();if(!this.open){this.removeAttribute('open')}
return FoxTheme.utils.waitForEvent(this,this.events.handleAfterHide)}}
async showWithTransition(){FoxTheme.Motion.animate(this.contentElement,{opacity:[0,1],visibility:'visible'},{duration:FoxTheme.config.motionReduced?0:0.6,easing:[0.7,0,0.2,1],delay:FoxTheme.config.motionReduced?0:0.1,});const translateY=this.level==='top'?'-105%':'2rem';return FoxTheme.Motion.animate(this.contentElement.firstElementChild,{transform:[`translateY(${translateY})`,'translateY(0)']},{duration:FoxTheme.config.motionReduced?0:0.6,easing:[0.7,0,0.2,1],}).finished}
async hideWithTransition(){FoxTheme.Motion.animate(this.contentElement,{opacity:0,visibility:'hidden'},{duration:FoxTheme.config.motionReduced?0:0.3,easing:[0.7,0,0.2,1],});const translateY=this.level==='top'?'-105%':'2rem';return FoxTheme.Motion.animate(this.contentElement.firstElementChild,{transform:`translateY(${translateY})`},{duration:FoxTheme.config.motionReduced?0:0.6,easing:[0.7,0,0.2,1],}).finished}
handleOutsideClick(event){const isClickInside=this.contains(event.target);const isClickOnDetailsDropdown=event.target.closest('details')instanceof DetailsDropdown;if(!isClickInside&&!isClickOnDetailsDropdown){this.open=!1}}
handleEscKeyPress(event){if(event.code==='Escape'){const targetMenu=event.target.closest('details[open]');if(targetMenu){targetMenu.open=!1}}}
handleFocusOut(event){if(event.relatedTarget&&!this.contains(event.relatedTarget)){this.open=!1}}
detectHover(event){if(this.trigger==='hover'){this.open=event.type==='mouseenter'}}
needsReverse(){const totalWidth=this.contentElement.offsetLeft+this.contentElement.clientWidth*2;if(totalWidth>window.innerWidth){this.contentElement.classList.add('needs-reverse')}}}
customElements.define('details-dropdown',DetailsDropdown,{extends:'details'});clearDropdownCount.set(DetailsDropdown,0);class DetailsMega extends DetailsDropdown{constructor(){super();if(Shopify.designMode){this.addEventListener('shopify:block:select',()=>{this.open=!0});this.addEventListener('shopify:block:deselect',()=>{this.open=!1})}}
async showWithTransition(){return FoxTheme.Motion.animate(this.contentElement.firstElementChild,{visibility:'visible',transform:['translateY(-100%)','translateY(0)'],},{duration:FoxTheme.config.motionReduced?0:0.5,easing:[0.39,0.575,0.565,1.0],}).finished}
async hideWithTransition(){return FoxTheme.Motion.animate(this.contentElement.firstElementChild,{visibility:'hidden',transform:'translateY(-100%)',},{duration:FoxTheme.config.motionReduced?0:0.5,easing:[0.39,0.575,0.565,1.0],}).finished}}
customElements.define('details-mega',DetailsMega,{extends:'details'});class MenuDrawerDetails extends HTMLDetailsElement{constructor(){super();this.summary.addEventListener('click',this.onSummaryClick.bind(this));this.closeButton.addEventListener('click',this.onCloseButtonClick.bind(this))}
get parent(){return this.closest('[data-parent]')}
get summary(){return this.querySelector('summary')}
get closeButton(){return this.querySelector('button')}
onSummaryClick(){setTimeout(()=>{this.parent.classList.add('active');this.classList.add('active');this.summary.setAttribute('aria-expanded',!0)},100)}
onCloseButtonClick(){this.parent.classList.remove('active');this.classList.remove('active');this.summary.setAttribute('aria-expanded',!1);this.closeAnimation()}
closeAnimation(){let animationStart;const handleAnimation=(time)=>{if(animationStart===undefined){animationStart=time}
const elapsedTime=time-animationStart;if(elapsedTime<400){window.requestAnimationFrame(handleAnimation)}else{this.removeAttribute('open')}};window.requestAnimationFrame(handleAnimation)}}
customElements.define('menu-drawer-details',MenuDrawerDetails,{extends:'details'});class MenuDrawer extends DrawerComponent{constructor(){super()}
get menuItems(){if(!this._menuItems){this._menuItems=this.querySelectorAll('.menu-drawer__menus:not(.active) > li')}
return this._menuItems}
get requiresBodyAppended(){return!1}
prepareToShow(){super.prepareToShow();setTimeout(()=>{this.animateMenuItems()},300)}
animateMenuItems(){if(FoxTheme.config.motionReduced)return;FoxTheme.Motion.animate(this.menuItems,{transform:['translateX(-20px)','translateX(0)'],opacity:[0,1],},{duration:0.6,easing:[0.075,0.82,0.165,1],delay:FoxTheme.Motion.stagger(0.1),}).finished.then(()=>{this.menuItems.forEach((item)=>item.removeAttribute('style'))})}
handleAfterHide(){super.handleAfterHide();setTimeout(()=>{this.querySelectorAll('details[is=menu-drawer-details]').forEach((menu)=>{menu.onCloseButtonClick()})})}}
customElements.define('menu-drawer',MenuDrawer);class MenuProductList extends HTMLElement{constructor(){super();this.initSlide();this.elementToFocus=this.querySelector('button')}
get container(){return this.querySelector('.swiper')}
get sliderPagination(){return this.querySelector('.swiper-pagination')}
get sliderNext(){return this.querySelector('.swiper-button-next')}
get sliderPrev(){return this.querySelector('.swiper-button-prev')}
get numberOfColumns(){return parseInt(this.dataset.columns)}
initSlide(){const slider=new FoxTheme.Carousel(this.container,{spaceBetween:10,slidesPerView:this.numberOfColumns,loop:!1,pagination:{el:this.sliderPagination,type:'fraction',},navigation:{nextEl:this.sliderNext,prevEl:this.sliderPrev,},focusableElements:'input, select, option, textarea, button, video, label',});slider.init();const focusableElements=FoxTheme.a11y.getFocusableElements(this);focusableElements.forEach((element)=>{element.addEventListener('focusin',function(){const slide=element.closest('.swiper-slide');slide&&slider.slider.slideTo(slider.slider.slides.indexOf(slide))})})}}
customElements.define('menu-product-list',MenuProductList);
class HeaderAccount extends HTMLElement {
  async connectedCallback() {
    const account = this.querySelector('shopify-account');

    if (!account) return;

    await customElements.whenDefined('shopify-account');

    const shadowRoot = await this.waitForShadowRoot(account);

    if (!shadowRoot) return;

    this.injectAnimation(shadowRoot);
  }

  waitForShadowRoot(element, timeout = 3000) {
    return new Promise((resolve) => {
      const start = performance.now();

      const check = () => {
        if (element.shadowRoot) {
          resolve(element.shadowRoot);
          return;
        }

        if (performance.now() - start > timeout) {
          resolve(null);
          return;
        }

        requestAnimationFrame(check);
      };

      check();
    });
  }

  injectAnimation(shadowRoot) {
    if (shadowRoot.querySelector('#custom-account-styles')) return;

    const style = document.createElement('style');
    style.id = 'custom-account-styles';

    style.textContent = `
      @keyframes dialogScaleIn {
        0% {
          transform: scale(0.8);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      @keyframes dialogScaleOut {
        0% {
          transform: scale(1);
          opacity: 1;
        }

        100% {
          transform: scale(0.8);
          opacity: 0;
        }
      }
      @keyframes dialogBackdropIn {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
      @keyframes dialogBackdropOut {
        0% {
          opacity: 1;
        }

        100% {
          opacity: 0;
        }
      }
      @media (min-width: 751px) {
        dialog .account {
          height: fit-content;
          background: var(--shopify-account-color-background);
          border-radius: inherit;
        }
        dialog[open] {
          animation: dialogScaleIn 0.6s cubic-bezier(0.7, 0, 0.2, 1) !important;
        }
        dialog.closing {
          animation: dialogScaleOut 0.6s cubic-bezier(0.7, 0, 0.2, 1) !important;
        }
        dialog[open]::backdrop {
          cursor: zoom-out;
          animation: dialogBackdropIn 0.8s cubic-bezier(0.7, 0, 0.2, 1) !important;
        }
        dialog.closing::backdrop {
          animation: dialogBackdropOut 0.8s cubic-bezier(0.7, 0, 0.2, 1) !important;
        } 
      }
      @media (max-width: 750px) {
        dialog .account__content {
          padding-bottom: 2.4rem;
        }
      }
    `;

    shadowRoot.prepend(style);
  }
}

customElements.define('header-account', HeaderAccount);